import { render } from "./FileManagerPage.vue?vue&type=template&id=6cee49e6&ts=true"
import script from "./FileManagerPage.vue?vue&type=script&lang=ts"
export * from "./FileManagerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__